import { combineReducers } from 'redux-immutable';
import { Map } from 'immutable';
import { decodePaReq, decodeCReq } from './utils/threeDS';

export const QUERYPARAMS = 'modules/axp-gravity-root/QUERYPARAMS';
export const SETAPIURL = 'modules/axp-gravity-root/SETAPIURL';
export const SETSPINNER = 'modules/axp-gravity-root/SETSPINNER';
export const SETSPINNERLOGO = 'modules/axp-gravity-root/SETSPINNERLOGO';
export const UPDATE_COMPLETION = 'modules/axp-gravity-root/UPDATE_COMPLETION';
export const UPDATE_DATA_HEADER = 'modules/axp-gravity-root/UPDATE_DATA_HEADER';
export const UPDATE_FALLBACK_DATA = 'modules/axp-gravity-root/UPDATE_FALLBACK_DATA';
export const UPDATE_PREV_ACS_TRANS_ID = 'modules/axp-gravity-root/UPDATE_PREV_ACS_TRANS_ID';
export const UPDATE_ROOT_SHOW_DIALOG = 'modules/axp-gravity-root/UPDATE_ROOT_SHOW_DIALOG';
export const UPDATE_ROOT_ABANDON_DATA = 'modules/axp-gravity-root/UPDATE_ROOT_ABANDON_DATA';

/* istanbul ignore next */
const showConfirmationDialog = (event) => {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue = '';
};

/* istanbul ignore next */
const logAbandon = (_, {
  postUrl, queryParams, incomingReq, scamScreen,
}) => {
  if (incomingReq) {
    const data = {
      screenId: scamScreen,
      eventCode: 'abandon',
      'acs-trans-id': queryParams.acsTransId,
      Authorization: queryParams.token,
    };
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(data)], {
        type: 'application/json',
      });
      navigator.sendBeacon(postUrl, blob);
    } else {
      // navigator API unavailable, use old method (IE)
      const req = new XMLHttpRequest();
      req.open('POST', postUrl, false);
      req.setRequestHeader('Content-Type', 'application/json');
      req.send(JSON.stringify(data));
    }
  } else {
    const data = new FormData();
    data.append('acs-trans-id', queryParams.acsTransId);
    data.append('screenId', scamScreen);
    data.append('eventCode', 'abandon');
    data.append('Authorization', queryParams.token);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(postUrl, data);
    } else {
      const req = new XMLHttpRequest();
      req.open('POST', postUrl, false);
      req.send(data);
    }
  }
};
/* istanbul ignore next */
export const buildInitialState = ({ req } = {}) => {
  let baseState = {
    acsTransId: {},
    spinner: true,
    spinnerLogo: true,
    gravityCheckoutUrl: null,
    incomingReq: null,
    completion: null,
    dataHeader: null,
    deviceInfo: false,
    fallback: '',
    prevAcsTransId: '',
    showRootDialog: false,
    abandonRootData: null,
  };

  const { log: loggit } = console;
  /* istanbul ignore next */
  /* eslint complexity: ["error", 25] */
  if (req && req.body) {
    const entireRequest = `REQUEST ${JSON.stringify(req)}`;
    loggit(entireRequest);

    let decodedAcsTransId = '';
    const { body, url } = req;

    const cReqTxn = url.includes('/3ds/v2');
    let usedCreq = 'creq';
    if (cReqTxn && !body[usedCreq]) usedCreq = ['CReq', 'cReq'].find((opt) => body[opt]);

    try {
      if (!cReqTxn) {
        const decodedPaReq = decodePaReq(body.PaReq || body.paReq);
        decodedAcsTransId = decodedPaReq.ThreeDSecure.Message[0].PAReq[0].CH[0].acctID[0];
      } else if (cReqTxn) {
        const decodedCReq = decodeCReq(body[usedCreq]);
        decodedAcsTransId = decodedCReq.acsTransID || decodeCReq(body[usedCreq], true).acsTransID;
      } else {
        decodedAcsTransId = 'Unable to decode acsTransId';
      }
    } catch (error) {
      decodedAcsTransId = 'Unable to decode acsTransId';
    }

    loggit(body);
    const requestBody = `REQUEST_BODY ${JSON.stringify(body)}`;
    loggit(requestBody);

    const sanitizedBody = { ...body };
    if (sanitizedBody.paReq) {
      const paReq = sanitizedBody.paReq;
      delete sanitizedBody.paReq;
      sanitizedBody.PaReq = paReq;
    }

    if (sanitizedBody.termUrl) {
      const termUrl = req.body.termUrl;
      delete sanitizedBody.termUrl;
      sanitizedBody.TermUrl = termUrl;
    }

    if (sanitizedBody.md) {
      const md = sanitizedBody.md;
      delete sanitizedBody.md;
      sanitizedBody.MD = md;
    }

    if (cReqTxn && usedCreq !== 'creq') {
      const creq = sanitizedBody[usedCreq];
      delete sanitizedBody[usedCreq];
      sanitizedBody.creq = creq;
    }

    const bodyType = ((body.PaReq || body.paReq) && 'PaReq')
      || ((body.creq || body.CReq || body.cReq) && 'CReq')
      || 'Unknown';

    baseState = {
      ...baseState,
      incomingReq: {
        type: bodyType,
        body: sanitizedBody,
        contentType: req.headers['content-type'],
        acsTransId: decodedAcsTransId || 'Unable to decode acsTransId',
      },
    };
  }

  return new Map({ rootReducer: new Map(baseState) });
};
/* istanbul ignore next */
const baseApiUrl = (queryParams, mockProcessPayAuthApi, gravityCheckoutUrl) => `${queryParams.mockEnabled === 'Y' ? mockProcessPayAuthApi : gravityCheckoutUrl}`;
/* istanbul ignore next */
export function rootReducer(state = buildInitialState(), { type, payload } = {}) {
  /* istanbul ignore next */
  const abandonHandler = (event) => logAbandon(event, payload);
  const abandonRootData = state.get('abandonRootData');
  switch (type) {
    case QUERYPARAMS:
      return state.set('acsTransId', payload);
    case SETAPIURL:
      return state.set('gravityCheckoutUrl', baseApiUrl(payload.queryparams, payload.mockProcessPayAuthApi, payload.gravityCheckoutUrl));
    case SETSPINNER:
      return state.set('spinner', payload);
    case SETSPINNERLOGO:
      return state.set('spinnerLogo', payload);
    case UPDATE_COMPLETION:
      return state.set('completion', payload);
    case UPDATE_DATA_HEADER:
      return state.set('dataHeader', payload);
    case UPDATE_FALLBACK_DATA:
      return state.set('fallback', payload);
    case UPDATE_PREV_ACS_TRANS_ID:
      return state.set('prevAcsTransId', payload);
      /* istanbul ignore next */
    case UPDATE_ROOT_SHOW_DIALOG:
      if (payload === true) window.addEventListener('beforeunload', showConfirmationDialog);
      if (payload === false) {
        window.removeEventListener('beforeunload', showConfirmationDialog);
        if (abandonRootData) window.removeEventListener('unload', abandonRootData.abandonHandler);
      }
      return state.set('showRootDialog', payload);
      /* istanbul ignore next */
    case UPDATE_ROOT_ABANDON_DATA:
      if (abandonRootData) window.removeEventListener('unload', abandonRootData.abandonHandler);
      window.addEventListener('unload', abandonHandler);
      return state.set('abandonRootData', { ...payload, abandonHandler }); // keep reference to abandon handler across reducer calls
    default: return state;
  }
}

const reducer = combineReducers({
  rootReducer,
});

reducer.buildInitialState = buildInitialState;

export default reducer;
